import { AdminLabOrderPrintLog } from "pwapi";

import { PWAction } from "utils/redux";

import {
  ADMIN_ORDERS_PRINT_RETRIEVE_FAILURE,
  ADMIN_ORDERS_PRINT_RETRIEVE_REQUEST,
  ADMIN_ORDERS_PRINT_RETRIEVE_SUCCESS,
  ADMIN_UPDATE_ORDERS_PRINT_SUCCESS,
} from "../../actions/adminConstants";

export interface LabOrderPrintLogState {
  [key: number]: AdminLabOrderPrintLog | undefined;
}

export const initialState: LabOrderPrintLogState = {};

const reducer = (
  state = initialState,
  action: PWAction
): LabOrderPrintLogState => {
  switch (action.type) {
    case ADMIN_ORDERS_PRINT_RETRIEVE_REQUEST:
    case ADMIN_ORDERS_PRINT_RETRIEVE_FAILURE:
      return initialState;
    case ADMIN_ORDERS_PRINT_RETRIEVE_SUCCESS:
    case ADMIN_UPDATE_ORDERS_PRINT_SUCCESS:
      return {
        [action.payload.response.id]: action.payload.response,
      };
    default:
      return state;
  }
};

export default reducer;
